import React from "react"
import { Text } from "rebass"
import { get } from "lodash"
import { makeStyles } from "@material-ui/core/styles"
import LinearProgress from "@material-ui/core/LinearProgress"
import { useQueryWithStore } from "react-admin"

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}))
const EditProductField = props => {
  const classes = useStyles()

  const { record, source, updateField, resource, isSetProduct } = props
  const { loaded, data } = useQueryWithStore({
    type: "getOne",
    resource: "products",
    payload: { id: record.product_id ? record.product_id : 1 },
  })
  if (!loaded) {
    return (
      <div className={classes.root}>
        <LinearProgress variant="query" />
      </div>
    )
  }
  if (data && data.id && isSetProduct) {
    updateField(resource, data)
  }

  return <Text>{get(data, source, "")}</Text>
}

export default EditProductField
